// Constants
const OPTION_VALUES = {
  RENTAL_HOME_VISIT: 'Rental Home Visit Service',
  PURCHASE: 'Purchase',
  RENTAL_SELF_SERVICE: 'Rental Self Service',
};

const OPTION_VALUES_KO = {
  PURCHASE: '구매',
  RENTAL_HOME_VISIT: '임대 주택 방문 서비스',
  RENTAL_SELF_SERVICE: '렌탈 셀프 서비스',
};

const OPTION_VALUES_CN = {
  PURCHASE: '购买',
  RENTAL_HOME_VISIT: '出租房屋参观服务',
  RENTAL_SELF_SERVICE: '自助租赁服务',
};

function getOptionValue(optionValue) {
  const language = document.documentElement.lang;
  if (language === 'en') {
    return OPTION_VALUES[optionValue];
  } else if (language === 'zh-CN') {
    return OPTION_VALUES_CN[optionValue];
  } else if (language === 'ko') {
    return OPTION_VALUES_KO[optionValue];
  } else {
    return OPTION_VALUES[optionValue];
  }
}

const errorMessages = {
  en: 'We apologize, but this zip code is not within our service area. For more information, please contact us.',
  zhCN: '我们深表歉意，但此邮政编码不在我们的服务范围内。有关更多信息，请与我们联系。',
  ko: '우리는 이 우편 번호가 우리 서비스 지역 내에 없다는 점을 사과합니다. 자세한 내용은 연락주세요.',
  default:
    'We apologize, but this zip code is not within our service area. For more information, please contact us.',
};

const errorMessagesSelfService = {
  en: 'This area is ineligible for installation. Please contact our Customer Center.',
  zhCN: '该地区不符合安装条件。请联系客户服务中心。',
  ko: '해당 지역은 설치가 불가능합니다. 고객센터로 문의해 주세요.',
  default:
    'This area is ineligible for installation. Please contact our Customer Center.',
};

const successMessages = {
  en: 'The above zip code is within our service area. Please select your service option below. \n* New installations are subject to local availability.',
  zhCN: '此邮政编码在我们的服务范围内。请选择您的服务选项。',
  ko: '이 우편 번호가 우리 서비스 지역 내에 있습니다. 아래에서 서비스 옵션을 선택하세요.',
  default:
    'The above zip code is within our service area. Please select your service option below. \n* New installations are subject to local availability.',
};

const getErrorMessage = () => {
  const language = document.documentElement.lang;
  return errorMessages[language] || errorMessages.default;
};

const getErrorMessageSelfService = () => {
  const language = document.documentElement.lang;
  return errorMessagesSelfService[language] || errorMessagesSelfService.default;
};

const getSuccessMessage = () => {
  const language = document.documentElement.lang;
  return successMessages[language] || successMessages.default;
};

const SELECTORS = {
  mainProductTemplate: '.main-product-template',
  zipcodeContainer: '#submit-check-coverage',
  checkZipcode: '#submit-check-coverage div.check-zipcode',
  zipcodeInput: '#submit-check-coverage input#zipcode',
  validatedContainer: '.show-on-validated-container',
  serviceInput: '.show-on-validated-container input[name="Service"]',
  message: '#submit-check-coverage .message',
  buttonContainer: '#button-check-zipcode-container',
  glyphiconSearch: '#submit-check-coverage .check-zipcode .glyphicon-search',
};

const STORAGE_KEY = 'coway_validated_zipcode';

// API Configuration - will be set from inline script in main-product.liquid
let API_BASE_URL = window.COWAY_API_BASE_URL || '';
let API_CLIENT_ID = window.COWAY_API_CLIENT_ID || '';
let API_CLIENT_SECRET = window.COWAY_API_CLIENT_SECRET || '';
let API_SHOP = window.COWAY_API_SHOP || '';
let API_URL = '';

// Initialize API URL when config is available
function initApiConfig() {
  if (API_BASE_URL) {
    API_URL = `${API_BASE_URL}/api/v1/products/zipcode`;
  }
}

// Global functions
function getParentVariants() {
  const productInfo = document.querySelector(SELECTORS.mainProductTemplate);
  if (!productInfo) return [];

  const sectionId = productInfo.getAttribute('data-section');
  const variantScript = document.querySelector(`#ProductVariants-${sectionId}`);

  if (!variantScript) return [];

  try {
    const variantData = JSON.parse(variantScript.textContent);
    const optionValues = variantData.option_values || [];

    return optionValues.map(optionValue => ({
      name: optionValue.name,
      id: optionValue.id,
    }));
  } catch (e) {
    console.error('Error parsing variant data:', e);
    return [];
  }
}

function show_error_postalcode(message) {
  const $checkZipcode = $(SELECTORS.checkZipcode);
  $checkZipcode.find('#toast-container').remove();

  const messageHtml = `
    <div id="toast-container" style="position: relative; margin-top: 15px; margin-bottom: -30px; width: 100%;">
      <div class="toast toast-warning" aria-live="assertive" style="display: block; width: 100%;">
        <div class="toast-message">${message}</div>
      </div>
    </div>
  `;

  $checkZipcode.append(messageHtml);
}

function getServiceInput(optionValue) {
  return $(`${SELECTORS.validatedContainer} input[value="${optionValue}"]`);
}

function toggleServiceOption(optionValue, disabled) {
  getServiceInput(optionValue).prop('disabled', disabled);
}

function updateDurationFieldsetVisibility() {
  const tryUpdate = (attempts = 0) => {
    const variantSelects = document.querySelector('variant-selects');
    if (
      variantSelects &&
      typeof variantSelects.toggleDurationFieldset === 'function'
    ) {
      variantSelects.toggleDurationFieldset();
    } else if (attempts < 5) {
      setTimeout(() => tryUpdate(attempts + 1), 100);
    }
  };

  tryUpdate();
  setTimeout(() => tryUpdate(), 150);
}

function autoSelectAvailableOption(dataRes) {
  // Reset all options
  $(SELECTORS.serviceInput).prop('checked', false);

  // Auto select first available option
  const selectionOrder = [
    { condition: dataRes.rental, value: getOptionValue('RENTAL_HOME_VISIT') },
    { condition: dataRes.sale, value: getOptionValue('PURCHASE') },
    {
      condition: dataRes.selfService,
      value: getOptionValue('RENTAL_SELF_SERVICE'),
    },
  ];

  for (const option of selectionOrder) {
    if (option.condition) {
      const serviceInput = getServiceInput(option.value);
      serviceInput.prop('checked', true);
      serviceInput.trigger('change');

      const variantSelects = document.querySelector('variant-selects');
      if (variantSelects) {
        variantSelects.dispatchEvent(new Event('change'));
      }

      setTimeout(() => {
        updateDurationFieldsetVisibility();
      }, 50);
      return;
    }
  }
}

function updateUIAfterValidation() {
  $(SELECTORS.zipcodeContainer).addClass('validated');
  $(SELECTORS.glyphiconSearch).hide();
  $(SELECTORS.buttonContainer).html(
    '<button id="button-remove-zipcode" onclick="remove_postcode()" type="submit"><span class="input-group-addon glyphicon glyphicon-remove-sign" aria-hidden="true"></span></button>'
  );
}

function handleServiceOptions(dataRes, parentVariants) {
  const hasSelfService = parentVariants.some(
    v => v.name === getOptionValue('RENTAL_SELF_SERVICE')
  );

  // Toggle service options based on availability
  toggleServiceOption(getOptionValue('RENTAL_HOME_VISIT'), !dataRes.rental);
  toggleServiceOption(getOptionValue('PURCHASE'), !dataRes.sale);

  if (hasSelfService) {
    toggleServiceOption(
      getOptionValue('RENTAL_SELF_SERVICE'),
      !dataRes.selfService
    );
  }

  autoSelectAvailableOption(dataRes);
}

function handleRentalOrSaleCase(dataRes, parentVariants) {
  $(SELECTORS.message).text(getSuccessMessage());
  $(SELECTORS.validatedContainer).show();
  handleServiceOptions(dataRes, parentVariants);
  // Update Duration fieldset visibility after showing validated container
  updateDurationFieldsetVisibility();
}

function handleSelfServiceOnlyCase(dataRes, parentVariants) {
  const hasSelfService = parentVariants.some(
    v => v.name === getOptionValue('RENTAL_SELF_SERVICE')
  );
  const $validatedContainer = $(SELECTORS.validatedContainer);

  if (hasSelfService) {
    $validatedContainer.show();
    toggleServiceOption(getOptionValue('RENTAL_HOME_VISIT'), true);
    toggleServiceOption(getOptionValue('PURCHASE'), true);
    toggleServiceOption(getOptionValue('RENTAL_SELF_SERVICE'), false);
    autoSelectAvailableOption(dataRes);
    updateDurationFieldsetVisibility();
  } else {
    $validatedContainer.hide();
    $(SELECTORS.message).text(getErrorMessageSelfService());
  }
}

function saveZipcodeToStorage(zipcode) {
  try {
    localStorage.setItem(STORAGE_KEY, zipcode);
  } catch (e) {
    console.error('Error saving zipcode to localStorage:', e);
  }
}

function getZipcodeFromStorage() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    console.error('Error getting zipcode from localStorage:', e);
    return null;
  }
}

function clearZipcodeFromStorage() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.error('Error clearing zipcode from localStorage:', e);
  }
}

function disableZipcodeInput(disabled) {
  $(SELECTORS.zipcodeInput).prop('disabled', disabled);
}

function validate_postcode() {
  // Get SKU from current selected variant
  let sku = '';
  const productInfo = $(SELECTORS.mainProductTemplate);
  const sectionId = productInfo.data('section');

  // Try to get variant data from JSON script
  const variantScript = document.querySelector(`#ProductVariants-${sectionId}`);
  if (variantScript) {
    try {
      const variantData = JSON.parse(variantScript.textContent);
      const variants = variantData.variants || [];

      // Get currently selected variant ID from the page
      const selectedVariantId = $('input[name="id"]').val();

      if (selectedVariantId) {
        // Find the variant with matching ID
        const selectedVariant = variants.find(v => v.id == selectedVariantId);
        if (selectedVariant && selectedVariant.sku) {
          sku = selectedVariant.sku;
        }
      }

      // Fallback: if no selected variant, use first variant's SKU
      if (!sku && variants.length > 0 && variants[0].sku) {
        sku = variants[0].sku;
      }
    } catch (e) {
      console.error('Error parsing variant data:', e);
    }
  }

  const zipcode = $(SELECTORS.zipcodeInput).val().trim();

  if (!zipcode) {
    return toastr.warning('Enter zipcode');
  }

  // Ensure API config is initialized
  initApiConfig();

  if (!API_URL) {
    console.error('API configuration not available');
    return show_error_postalcode(getErrorMessage());
  }

  const parentVariants = getParentVariants();
  const ERROR_MESSAGE = getErrorMessage();

  $.ajax({
    url: `${API_URL}/${zipcode}/${sku}`,
    type: 'GET',
    headers: {
      'X-Client-Id': API_CLIENT_ID,
      'X-Client-Secret': API_CLIENT_SECRET,
      'X-Shop': API_SHOP,
    },
    beforeSend: function () {
      $(SELECTORS.checkZipcode).find('#toast-container').remove();
      $('#zipcode-loading-spinner').show();
      $('#button-check-zipcode').prop('disabled', true);
    },
    success: function (response) {
      $('#zipcode-loading-spinner').hide();
      $('#button-check-zipcode').prop('disabled', false);
      if (!response) return;

      const dataRes = {
        rental: response.rental || false,
        sale: response.sale || false,
        selfService: response.selfService || false,
        installLvl: response.installLvl,
      };

      updateUIAfterValidation();

      // Check if no service is available
      if (!dataRes.selfService && !dataRes.rental && !dataRes.sale) {
        show_error_postalcode(ERROR_MESSAGE);
        // Don't save zipcode if validation failed
        return;
      }

      // Save zipcode to localStorage when validation is successful
      saveZipcodeToStorage(zipcode);

      // Handle rental or sale case
      if (dataRes.rental || dataRes.sale) {
        handleRentalOrSaleCase(dataRes, parentVariants);
        // disable zipcode input
        disableZipcodeInput(true);
        return;
      }

      // Handle self-service only case
      if (dataRes.selfService && !dataRes.rental && !dataRes.sale) {
        handleSelfServiceOnlyCase(dataRes, parentVariants);
        // disable zipcode input
        disableZipcodeInput(true);
        return;
      }
    },
    error: function () {
      $('#zipcode-loading-spinner').hide();
      $('#button-check-zipcode').prop('disabled', false);
      show_error_postalcode(ERROR_MESSAGE);
      // Don't save zipcode if validation failed
    },
  });
}

function remove_postcode() {
  $(SELECTORS.validatedContainer).hide();
  $(SELECTORS.zipcodeContainer).removeClass('validated');
  $(SELECTORS.buttonContainer).html(
    '<button id="button-check-zipcode" onclick="validate_postcode()" type="submit">Check</button>'
  );
  $(SELECTORS.glyphiconSearch).show();
  $(SELECTORS.message).text('');
  $(SELECTORS.zipcodeInput).val('');
  // enable zipcode input
  disableZipcodeInput(false);
  // Clear zipcode from storage when user removes it
  clearZipcodeFromStorage();
}

let isApplyingZipcode = false;

function applySavedZipcode() {
  // Prevent multiple simultaneous applications
  if (isApplyingZipcode) return;

  const savedZipcode = getZipcodeFromStorage();
  if (!savedZipcode) return;

  const $zipcodeInput = $(SELECTORS.zipcodeInput);
  if (!$zipcodeInput.length) return;

  const currentZipcode = $zipcodeInput.val().trim();

  // Only apply if input is empty or different from saved zipcode
  if (!currentZipcode || currentZipcode !== savedZipcode) {
    isApplyingZipcode = true;
    $zipcodeInput.val(savedZipcode);
    // Automatically validate the saved zipcode
    validate_postcode();

    // Reset flag after validation completes (with delay)
    setTimeout(function () {
      isApplyingZipcode = false;
    }, 2000);
  } else if (
    currentZipcode === savedZipcode &&
    !$(SELECTORS.zipcodeContainer).hasClass('validated')
  ) {
    // If zipcode matches but not validated yet, validate it
    isApplyingZipcode = true;
    validate_postcode();

    setTimeout(function () {
      isApplyingZipcode = false;
    }, 2000);
  }
}

// Auto-apply saved zipcode when page loads
$(document).ready(function () {
  // Initialize API config on page load
  initApiConfig();

  // Wait a bit for DOM to be fully ready
  setTimeout(function () {
    applySavedZipcode();
  }, 500);

  // Listen for product-info:loaded event (when product is swapped/updated via AJAX)
  document.addEventListener('product-info:loaded', function () {
    // Wait a bit for DOM to be updated
    setTimeout(function () {
      applySavedZipcode();
    }, 300);
  });

  // Also listen for DOM mutations to catch product swaps
  let mutationTimeout = null;
  const observer = new MutationObserver(function (mutations) {
    let shouldApply = false;

    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            // Check if product-info element was added or updated
            if (
              node.classList &&
              node.classList.contains('main-product-template')
            ) {
              shouldApply = true;
            }
            // Check if zipcode input was added
            if (
              node.querySelector &&
              node.querySelector(SELECTORS.zipcodeInput)
            ) {
              shouldApply = true;
            }
          }
        });
      }
    });

    // Debounce: only apply once after mutations stop
    if (shouldApply) {
      clearTimeout(mutationTimeout);
      mutationTimeout = setTimeout(function () {
        applySavedZipcode();
      }, 500);
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
